<template>
  <div class="exness">
    <div class="exness__inner">

      <!-- Header -->
      <div class="exness__header exness__fade-in">
        <h1 class="exness__title">
          {{ $t('about.feesbackcome') }}
          <span class="exness__title-accent">EXNESS &amp; VANTAGE &amp; PU PRIME</span>
        </h1>
        <p class="exness__subtitle">{{ $t('about.discoverOpp') }}</p>
      </div>

      <!-- Tree -->
      <div class="exness__tree">

        <!-- L1: Root -->
        <div class="exness__level exness__fade-in">
          <div class="exness__node exness__node--primary">
            <div class="exness__node-title">🎯 {{ $t('about.policyParnerSHC') }}</div>
            <div class="exness__node-sub">{{ $t('about.smartCommisSys') }}</div>
          </div>
          <div class="exness__conn exness__conn--v"></div>
        </div>

        <!-- L2: You -->
        <div class="exness__level exness__fade-in">
          <div class="exness__node exness__node--you">
            <span class="exness__you-icon">👤</span>
            <div>
              <div class="exness__node-title">{{ $t('common.you') }}</div>
              <div class="exness__node-sub">{{ $t('about.coordinationCenter') }}</div>
            </div>
          </div>
          <!-- Fork: vertical + horizontal bar -->
          <div class="exness__fork">
            <div class="exness__fork-v"></div>
            <div class="exness__fork-h"></div>
            <div class="exness__fork-leg exness__fork-leg--left"></div>
            <div class="exness__fork-leg exness__fork-leg--right"></div>
          </div>
        </div>

        <!-- L3 + L4 + L5: Branches -->
        <div class="exness__branches exness__fade-in">

          <!-- Left branch: Customer -->
          <div class="exness__branch">
            <div class="exness__node exness__node--action">
              <span>👥</span>
              <div>
                <div class="exness__node-title">{{ $t('common.introduce') }} {{ $t('common.customer') }}</div>
                <div class="exness__node-sub">{{ $t('about.expandNetwork') }}</div>
              </div>
            </div>
            <div class="exness__conn exness__conn--v"></div>
            <div class="exness__node exness__node--result">
              <div class="exness__pct">80%</div>
              <div class="exness__result-label">{{ $t('about.commissionCustomer') }}</div>
            </div>
          </div>

          <!-- Right branch: Partner -->
          <div class="exness__branch">
            <div class="exness__node exness__node--action">
              <span>🤝</span>
              <div>
                <div class="exness__node-title">{{ $t('common.introduce') }} {{ $t('common.parner') }}</div>
                <div class="exness__node-sub">{{ $t('about.buildTeam') }}</div>
              </div>
            </div>
            <div class="exness__conn exness__conn--v"></div>
            <div class="exness__node exness__node--result">
              <div class="exness__pct">10%</div>
              <div class="exness__result-label">{{ $t('about.totalParnerSuch') }}</div>
            </div>
            <!-- Sub-fork -->
            <div class="exness__fork exness__fork--sm">
              <div class="exness__fork-v"></div>
              <div class="exness__fork-h exness__fork-h--sm"></div>
              <div class="exness__fork-leg exness__fork-leg--left"></div>
              <div class="exness__fork-leg exness__fork-leg--right"></div>
            </div>
            <div class="exness__sub-row">
              <div class="exness__node exness__node--sub">
                <div class="exness__pct exness__pct--sm">80%</div>
                <div class="exness__sub-label">{{ $t('about.customerLive') }}</div>
              </div>
              <div class="exness__node exness__node--sub">
                <div class="exness__pct exness__pct--sm">10%</div>
                <div class="exness__sub-label">{{ $t('about.incomeUnderParner') }}</div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- CTA -->
      <div class="exness__cta exness__fade-in">
        <button @click="goToContact" class="exness__cta-btn">
          {{ $t('common.startNow') }}
        </button>
        <p class="exness__cta-sub">{{ $t('common.joinWithSHC') }}</p>
      </div>

    </div>
  </div>
</template>

<script src="./tree-exness.js"></script>
<style src="./tree-exness.scss" lang="scss"></style>
